import { DateTime } from 'luxon';

export const isUK = country => ['uk', 'gb'].includes(String(country || '').trim().toLowerCase());
export const tenantTimezone = settings => settings?.timezone || (isUK(settings?.country) ? 'Europe/London' : 'Europe/Athens');
export const displayLocale = language => ({en: 'en-GB', el: 'el-GR', ar: 'ar-EG', sq: 'sq-AL'}[language] || language || 'en-GB');
export const formatDate = (value, language, zone) => {
  const date = DateTime.fromJSDate(new Date(value), { zone });
  return date.isValid ? date.setLocale(displayLocale(language)).toLocaleString(DateTime.DATE_SHORT) : '';
};

// Calendar selections represent the shop's wall clock, regardless of the browser's zone.
export const shopDateTime = (date, time, zone) => date.setZone(zone, { keepLocalTime: true }).set({
  hour: time.hour, minute: time.minute, second: 0, millisecond: 0
});
export const bookingStart = (booking, zone) => DateTime.fromISO(booking.bookingDate.slice(0, 10), { zone }).set({
  hour: +booking.bookingHour.split(':')[0], minute: +booking.bookingHour.split(':')[1]
});
